// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    /* Store Custom Code - Start */
    button: {
        field: {
            enabled: false,
        },
    },
    /* Store Custom Code - End */
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    typography: {
        fontFamily: {
            /* Store Custom Code - Start */
            title: `'Roboto', Helvetica, sans-serif`,
            base: `'Roboto', Helvetica, sans-serif`,
            /* Store Custom Code - End */
        },
    },
    /* Store Custom Code - Start */
    header: {
        height: pxToRemArray([70, null, null, null, null]),
        padding: pxToRemArray([12]),
        itemSpacing: pxToRemArray([2, null, 30, 40, 50]),
    },
    menu: {
        mainNavigation: {
            underlineSize: pxToRem(7),
        },
        secondaryNavigation: {
            itemSpacing: pxToRemArray([30, null, null, 30, 30]),
        },
        panel: {
            rowPadding: pxToRem(20),
        },
    },
    common: {
        contentRadius: pxToRem(0),
    },
    /* Store Custom Code - End */
};

export default design;
